import React from "react";
import { useMemo } from "react";

import Text from "src/components/text";
import { Analytics, DealRoomItem } from "src/types/reports";

import _ from "lodash";
import styles from "./dealRoomCard.module.scss";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";


export interface DealRoomActivityItem {
  dealRoom: DealRoomItem;
  analytics: Analytics;
}

export interface DealRoomCardProps {
  item: DealRoomActivityItem;
}

export const DealRoomCard: React.FC<DealRoomCardProps> = ({ item }) => {
  const { dealRoom, analytics } = item;

  const createdBy = useMemo(() => {
    return dealRoom.createdBy?.firstName
      ? `${dealRoom.createdBy.firstName} ${dealRoom.createdBy.lastName || ""}`.trim()
      : "Unknown";
  }, [dealRoom.createdBy]);

  const thumbnail = useMemo(() => {
    return dealRoom.icon?.thumbnail || DefaultAssetIcon;
  }, [dealRoom.icon?.thumbnail]);

  return (
    <a
      href={`/deal-room/${dealRoom.dealRoomId}`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkWrapper}
    >
      <div className={styles.card}>
        <img
          src={thumbnail}
          alt={_.get(dealRoom, "name", "")}
          className={styles.thumbnailIcon}
        />
        <div className={styles.content}>
          <Text
            lines={1}
            className={styles.title}
            text={_.get(dealRoom, "name", "")}
          />
          <div className={styles.metrics}>
            <span>{dealRoom.assetsCount || 0} Assets</span>
            <span>{analytics.views || 0} Views</span>
            <span>{dealRoom.totalPeopleInvolved || 0} Stakeholders</span>
          </div>
          <div className={styles.meta}>
            Created by: {" "}
            <Text lines={1} className={styles.author} text={createdBy} />
          </div>
        </div>
      </div>
    </a>
  );
};
